import React from 'react';

import CatalogShell from './CatalogShell';

const NotificationCategories: React.FC = () => (
  <CatalogShell
    slug="notification-categories"
    title="Notification categories"
    breadcrumbLabel="Notification categories"
    emptyBody="Categories group notifications by purpose — transactional, marketing, ops. Drives rate-limits + tenant-side opt-outs."
    addCtaLabel="Add first category"
  />
);

export default NotificationCategories;
